import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    session: {},
    statusCode: 0,
    message: null,
  },
  reducers: {
    setSession(state, action) {
      // Guardar toda la respuesta
      state.session = action.payload.data;
      state.statusCode = action.payload.code;
      state.message = action.payload.message;
    },

    clean(state) {
      state.session = {};
      state.statusCode = 0;
      state.message = null;
    }
  },
});

export const { setSession, clean } = sessionSlice.actions;
export default sessionSlice.reducer;